export default __webpack_public_path__ + "static/media/coins.9025b158.svg";